var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _radialGradient, _path4, _path5, _path6, _linearGradient4, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Macbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 7.196,
    x2: 39.472,
    y1: 1168.822,
    y2: 1196.054,
    gradientTransform: "translate(0 -1162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M43,36H5c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h38c1.1,0,2,0.9,2,2v26C45,35.1,44.1,36,43,36z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 24,
    x2: 24,
    y1: 1197.987,
    y2: 1204.012,
    gradientTransform: "translate(0 -1162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M33,40v-4H15v4L0,39.7V41c0,0.6,0.4,1,1,1h46c0.6,0,1-0.4,1-1v-1.3L33,40z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 23.999,
    x2: 23.999,
    y1: 1197.991,
    y2: 1202.008,
    gradientTransform: "translate(0 -1162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#484b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#565b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#626a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#6b757d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#717b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#727d86"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M47.9,39.5L45,36.6c-0.4-0.4-0.9-0.6-1.4-0.6H4.4c-0.5,0-1,0.2-1.4,0.6l-2.9,2.9C-0.1,39.7,0,40,0.3,40h17.1 c0.4,0,0.7-0.2,0.9-0.6l0.4-0.9c0.2-0.3,0.5-0.6,0.9-0.6h8.8c0.4,0,0.7,0.2,0.9,0.6l0.4,0.9c0.2,0.3,0.5,0.6,0.9,0.6h17.1 C48,40,48.1,39.7,47.9,39.5z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 42.958,
    cy: -175.731,
    r: 34.553,
    gradientTransform: "matrix(1 0 0 -1.0833 0 -156.167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e6fd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#aa73c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ca7f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc914d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M43,8H5v26h38V8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43,6H27v9c0,1.1,0.9,2,2,2h3v3c0,0.8,0.7,1.5,1.5,1.5c0.4,0,0.8-0.2,1.1-0.4l4.1-4.1H45V8C45,6.9,44.1,6,43,6 z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43,6H27.5v9c0,0.8,0.7,1.5,1.5,1.5h3.5V20c0,0.6,0.5,1,1,1c0.3,0,0.5-0.1,0.7-0.3l4.2-4.2H45V8 C45,6.9,44.1,6,43,6z",
    opacity: 0.07
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 32.13,
    x2: 44.008,
    y1: 344.449,
    y2: 363.775,
    gradientTransform: "translate(0 -346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737be6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4750b3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M47,0H29c-0.6,0-1,0.5-1,1v14c0,0.6,0.5,1,1,1h4v4c0,0.4,0.5,0.7,0.9,0.4l4.3-4.3H47c0.6,0,1-0.5,1-1V1 C48,0.5,47.5,0,47,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Macbook);
export default __webpack_public_path__ + "static/media/icons8-macbook.a32ccd2d242e917581243d958121b0eb.svg";
export { ForwardRef as ReactComponent };